
import { NgbTimeStruct, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
export class FnDateTimeModel implements NgbDateStruct, NgbTimeStruct {
  year: number;
  month: number;
  day: number;
  hour = 0;
  minute = 0;
  second = 0;

  timeZoneOffset: number;

  getDate(): Date {
    const year = Number(this.year.toString().padStart(2, "0"));
    const month = Number(this.month.toString().padStart(2, "0"));
    const day = Number(this.day.toString().padStart(2, "0"));
    const hour = Number(this.hour.toString().padStart(2, "0"));
    const minute = Number(this.minute.toString().padStart(2, "0"));
    const second = Number(this.second.toString().padStart(2, "0"));
    return new Date(year, month - 1, day, hour, minute, second);
  }

  setDetails(busiDate: Date) {
    this.year = busiDate.getFullYear();
    this.month = busiDate.getMonth() + 1;
    this.day = busiDate.getDate();
    this.hour = busiDate.getHours();
    this.minute = busiDate.getMinutes();
    this.second = busiDate.getSeconds();
  }
}
